import { atom } from "recoil";

const confettiEffectAtom = atom({
  key: "conffetiEffect",
  default: false,
});

export default confettiEffectAtom;
